module.exports = "<div class=\"subnav-header \">\n  <!--<sub-navigation-title :title-only=\"true\" :title=\"$t('BLOCK_PARC')\" />-->\n  <!-- <v-btn flat block>\n    <span class=\"white--text py-2 px-0 subnav-header__line\"> {{$t('BLOCK_PARC')}}</span>\n    <v-spacer></v-spacer>\n    <v-icon color=\"secondary\" class=\"mr-2\">keyboard_arrow_down</v-icon>\n  </v-btn> -->\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/components/block-sidebar/template.html
// module id = qJUK
// module chunks = 0